<template>
  <div class="right_body action_body">
    <span class="btn right_sub_btn save_btn" @click.stop="onSubmitSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">采购订单_退货</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <PurchOrderUnReapHeader ref="orderreapheader" @onOrderDetail="onOrderDetail"></PurchOrderUnReapHeader>
    </div>
 
    <div class="coll list_content">
      <h2 class="title">
        <span>数据明细</span>
      </h2>
      <PurchOrderUnReapBody ref="orderReapBody"></PurchOrderUnReapBody>
    </div>
  </div>
</template>

<script>
import PurchOrderUnReapHeader from "./components/unreap/PurchOrderUnReapHeader.vue";
import PurchOrderUnReapBody from "./components/unreap/PurchOrderUnReapBody.vue";
import { purchaseOrderApi } from "api/PurchaseMngApi.js";

export default {
  components: {
    PurchOrderUnReapHeader,
    PurchOrderUnReapBody
  },
  methods: {
    onOrderDetail(details) {
      if (details) {
        this.$refs.orderReapBody.detailData = details;
      } else {
        this.$refs.orderReapBody.detailData = [];
      }
    },

    /**
     * 提交保存
     */
    async onSubmitSave() {
      // debugger;
      this.$refs.orderReapBody.onSubmitSaves()
      let vm = this,
        order; 
      order = vm.$refs.orderreapheader.headerData;
      order.details=vm.$refs.orderReapBody.PurchOrderList;
      console.log(order.details.length)
			if(order.details.length == 0){ 
				this.$message.error('请勾选需要提交的数据明细！');
				return false;
			}
      if(!order.companyName){ 
				this.$message.error('请选择公司');
				return false;
			}
			if(!order.supplierDesc){ 
				this.$message.error('请选择供应商');
				return false;
			}
			let isTrue = true;
			order.details.forEach((item)=>{
				if(!item.returnQuantity){ 
					this.$message.error('请选择退货数量');
					isTrue = false;
					return false;
				}
			})
			if(!isTrue) return false;
      console.log(JSON.stringify(order));
      let res = await this.$post(purchaseOrderApi.returnsUrl, order);
      if (res.type == "F") {
        this.$message.error(res.msg);
        return;
      }
      this.$confirm(
        "采购订单号 " +
          res.data.purchaseOrderNo +
          " 退货成功;是否继续？",
        "提示",
        {
          confirmButtonText: "继续",
          cancelButtonText: "退出",
          type: "success"
        }
      )
        .then(() => {
          vm.clearOrder();
          vm.$router.push({ name: "business-purchaseorder-purchaseordernew" });
        })
        .catch(() => {
          vm.$router.push({
            name: "business-purchaseorder-purchaseordersearch"
          });
          vm.clearOrder();
          vm.close({ tagName: "business-purchaseorder-purchaseordernew" });
        });
    }
  }
};
</script>

<style scoped>
</style>